/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/DeliveryDate.js
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Tue Apr 22 2025
 */

import React, { useState, useContext, useMemo } from 'react';
import { isEnabled } from '@root/_utils';
import { FormSection, RadioButtons, TimeZoneSelect, IEDateTimePicker, ShippingBanner, Banner } from "../../../_components";
import { TranslationsContext, FormContext } from "../../../_contexts";
import { validateDatePicker, getDeliveryDatepickerMin, getShippingLeadTime } from "../../../_utils";

export default function DeliveryDate() {

  const translations = useContext(TranslationsContext);
  const {
    settings,
    formData,
    formErrors,
    updateFormField,
    deliveryLeadTime,
    fulfillmentType,
  }  = useContext(FormContext);

  const handleChange = (value) => {
    updateFormField("properties._gcp_delivery_time", value);
  };
  const dateInputError = (formErrors._gcp_iso_delivery_date && formErrors._gcp_iso_delivery_date.error) || (formErrors._gcp_delivery_date && formErrors._gcp_delivery_date.error);

  const validInput = validateDatePicker();

  /**
   * Calculate the minimum date for the delivery date picker.
   *  - Digital: Current datetime
   *  - Physical: Add lead time days based on shipping country
   */
  const minDeliveryDate = useMemo(() => {
    return getDeliveryDatepickerMin(deliveryLeadTime);
  }, [deliveryLeadTime]);

  const shouldDisplayForm = (
    isEnabled(settings.global?.general?.enable_future_date) &&
    (formData.properties._gcp_send_to_self !== true || fulfillmentType === "physical")
  );

  return ((shouldDisplayForm) ?
    <FormSection
      title={translations.delivery_date_section_heading}
    >
      {fulfillmentType === "physical" && <Banner
        status={"info"}
        >
          {translations.physical_delivery_date_warning}
      </Banner>}
      <div className={"gc__delivery_picker_div"}>
        <RadioButtons
          groupName={"gc_delivery"}
          name="properties[_gcp_delivery_time]"
          options={[
            {
              value: "Send Now",
              label: translations.send_now_label
            },
            {
              value: "Send Later",
              label: translations.send_later_label
              
            }
          ]}
          onChange={handleChange}
          value={formData.properties._gcp_delivery_time}
          classes={"gc__no_column_row_gap gc__delivery-radio-container"}
        />
        {formData.properties._gcp_delivery_time === "Send Later" ? (
          <>

            {
              validInput === true ?
              <div className={"gc__input_container gc__datetime_container"}>
                <label className={"gc__input_label"}>&#x1F4C5;</label>
                <input
                  className={dateInputError ? "gc__datetime_input gc__input_field gc__datetime_input_invalid" : "gc__input_field  gc__datetime_input"}
                  name="fields[_gcp_helper_date]"
                  type="datetime-local"
                  onChange={(e) => {
                    updateFormField("properties._gcp_delivery_date", e.target.value);
                  }}
                  id="gcpDeliveryDate"
                  value={formData.properties._gcp_delivery_date || ""}
                  min={minDeliveryDate}
                />
              </div> :
              <IEDateTimePicker
                updateFormField={updateFormField}
                dateInputError={dateInputError}
              />
            }

            {
              formErrors._gcp_delivery_date && formErrors._gcp_delivery_date.error ?
                <span className={"gc__datetime_error_message"}>{formErrors._gcp_delivery_date.message}</span> :
                <></>
            }
            {
              formErrors._gcp_iso_delivery_date && formErrors._gcp_iso_delivery_date.error ?
                <span className={"gc__datetime_error_message"}>{formErrors._gcp_iso_delivery_date.message}</span> :
                <></>
            }
            <div className={"gc__input_container gc__datetime_container"}>
              <label className={"gc__input_label"}>&#127758;</label>
              <TimeZoneSelect
                onChange={(value) => {
                  updateFormField("properties._gcp_delivery_timezone",  value);
                }}
                name="properties[_gcp_delivery_timezone]"
                value={formData.properties._gcp_delivery_timezone}
              />
              {
                formErrors._gcp_delivery_time && formErrors._gcp_delivery_time.error ?
                  <span className={"gc__datetime_error_message"}>{formErrors._gcp_delivery_time.message}</span> :
                  <></>
              }
            </div>
          </>
        ) : (<></>)}
      </div>
    </FormSection>
  : <></>);
};
